import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Grid, Row, Col } from '@vds/grids';

const StyledCol = styled(Col)`
  color: black;
  padding-left: 0;
  padding-right: 0;
  label {
    font-weight: normal;
  }
`;

const StyledRow = styled(Row)`
  &:has(div[class*='StyledCol-LQDS'] > div.render-row-child:empty) {
     {
      display: none;
    }
  }
  &:has(div[class*='StyledCol-LQDS'] > div.render-row-child > div:empty) {
     {
      display: none;
    }
  }
`;

export default class SingleColGridLayout extends React.PureComponent {
  componentDidMount() {
    this.hideEmptyRows();
  }

  componentDidUpdate() {
    this.hideEmptyRows();
  }

  hideEmptyRows = () => {
    const { renderPredicate } = this.props;

    if (renderPredicate) {
      Object.keys(this.refs).forEach((refKey, index) => {
        const condtionalRenderIndexes = Object.keys(renderPredicate);
        if (condtionalRenderIndexes.includes(`${index}`)) {
          if (!renderPredicate[`${index}`]) {
            this.refs[refKey].parentNode.style.display = 'none';
          } else {
            this.refs[refKey].parentNode.style.display = '';
          }
        }
      });
    }
  };

  renderRow(content, index) {
    return (
      <StyledRow key={index}>
        <StyledCol>
          <div className="render-row-child" ref={`ref_${index}`} style={{ paddingLeft: '4px' }}>
            {content}
          </div>
        </StyledCol>
      </StyledRow>
    );
  }

  render() {
    const { rowGutter, colSizes, children } = this.props;

    return (
      <Grid rowGutter={rowGutter} colSizes={colSizes}>
        {Array.isArray(children) ? children.map((child, index) => this.renderRow(child, index)) : children && this.renderRow(children, 0)}
      </Grid>
    );
  }
}

SingleColGridLayout.propTypes = {
  rowGutter: PropTypes.string.isRequired,
  colSizes: PropTypes.object,
  children: PropTypes.any,
  renderPredicate: PropTypes.string,
};
